import { Routes } from '@angular/router';
import {LoginComponent} from "./login/login.component";
import {RegisterComponent} from "./register/register.component";
import {AuthenticateComponent} from "./authenticate/authenticate.component";
import {ErrorComponent} from "./error/error.component";
import {DashboardComponent} from "./dashboard/dashboard.component";
import {AuthGuard} from "./auth.guard";
import {UsersComponent} from "./users/users.component";
import {AdminGuard} from "./admin.guard";
import {ActivityComponent} from "./activity/activity.component";
import {AdminLoginComponent} from "./admin-login/admin-login.component";
import {UserComponent} from "./user/user.component";
import {AichatComponent} from "./aichat/aichat.component";
import {AnonymizationComponent} from "./anonymization/anonymization.component";

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'register/:id', component: RegisterComponent },
  { path: 'register/:id/:data', component: RegisterComponent },
  { path: 'authenticate/:token', component: AuthenticateComponent },
  { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
  { path: 'activity/:id', component: ActivityComponent, canActivate: [AuthGuard] },
  { path: 'aichat', component: AichatComponent, canActivate: [AuthGuard] },
  { path: 'admin/login', component: AdminLoginComponent },
  { path: 'admin/users', component: UsersComponent, canActivate: [AuthGuard, AdminGuard] },
  { path: 'admin/anonymization', component: AnonymizationComponent, canActivate: [AuthGuard, AdminGuard] },
  { path: 'admin/user/:id', component: UserComponent, canActivate: [AuthGuard, AdminGuard] },
  { path: 'not-found', component: ErrorComponent, data: { message: 'Stránka nenalezena!' } },
  { path: 'forbidden', component: ErrorComponent, data: { message: 'Nemáte oprávnění k přístupu na tuto stránku!' } },
  { path: 'invalid_token', component: ErrorComponent, data: { message: 'Platnost přihlášení vypršela, přihlaste se prosím znovu.' } },
  { path: 'error', component: ErrorComponent, data: { message: 'V aplikaci došlo k chybě.' } },
  { path: '**', redirectTo: 'not-found' }
];
